import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';

/**
 * The reporting user's e-mail as a link to their account: the users page searched by that address,
 * with the account's details opened (see PlatformUsersComponent query parameters).
 * `label` replaces the e-mail as the visible text (e.g. "Name (e-mail)").
 */
@Component({
  selector: 'app-user-account-link',
  standalone: true,
  imports: [CommonModule, RouterLink, TooltipModule],
  template: `
    @if (email && userGuid) {
      <a class="user-account-link" [routerLink]="['/platform-users']" [queryParams]="{ search: email, user: userGuid }"
        pTooltip="Otwórz konto użytkownika" tooltipPosition="top">
        {{ label || email }} <i class="pi pi-external-link" aria-hidden="true"></i>
      </a>
    } @else {
      <span>{{ label || email || fallback }}</span>
    }
  `,
  styles: [
    `
      .user-account-link {
        color: var(--primary-color, #3b82f6);
        text-decoration: none;
        word-break: break-all;

        &:hover {
          text-decoration: underline;
        }

        i {
          font-size: 0.7rem;
        }
      }
    `,
  ],
})
export class UserAccountLinkComponent {
  @Input() email?: string | null;
  @Input() userGuid?: string | null;
  @Input() label?: string | null;
  @Input() fallback = '—';
}
